import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  htmlFor?: string;
  isErrored?: boolean;
  isRequired?: boolean;
  label: string | ReactNode;
  labelAdditionalInfo?: string | ReactNode;
};
export const Label = ({
  className,
  htmlFor,
  isErrored = false,
  isRequired = false,
  label,
  labelAdditionalInfo,
}: Props) => (
  <label
    className={classnames(
      'inline-block text-14 font-semibold text-black',
      {
        'formik-errored': isErrored,
      },
      className,
    )}
    htmlFor={htmlFor}
  >
    {label}
    {isRequired && '*'}
    {labelAdditionalInfo && (
      <span className="ms-10 text-12 font-normal text-grey">{labelAdditionalInfo}</span>
    )}
  </label>
);
